import React from "react";
import "../styles/home.css";
import { Container, Row, Col } from "reactstrap";
import heroImg from "../assets/images/hero-img01.jpg";
import heroImg02 from "../assets/images/hero-img02.jpg";
import heroVideo from "../assets/images/hero-video.mp4";
import worldImg from "../assets/images/world.png";
import experienceImg from "../assets/images/experience.png"

import Subtitle from "../shared/Subtitle";
import SearchBar from "../shared/SearchBar";
import ServiceList from "../services/ServiceList";
import FeatureTourList from "../components/Feature-tours/FeatureTourList";
import MasonryGallery from "../components/Image-gallery/MasonryGallery";
import Testimonial from "../components/Testimonials/Testimonial";
import Newsletter from "../shared/Newsletter";


const Home = () => {
  return (
    <>
    <section>
      <Container>
        <Row>
          <Col lg="6">
            <div className="hero__content">
              <div className="hero__subtitle d-flex align-items-center">
                <Subtitle subtitle={"Know Before You Go"} />
                <img src={worldImg} alt="" />
              </div>
              <h1>
                Traveling opens the door to creating{" "}
                <span className="highlight">memories</span>
              </h1>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolore,
                molestiae perferendis. Libero similique facilis eius odio,
                consectetur quibusdam, dolore earum tenetur in unde dicta
                adipisci nemo nostrum nobis est quo.
              </p>
            </div>
          </Col>
          <Col lg='2'>
            <div className="hero__img-box">
              <img src={heroImg} alt="heroImg" />
            </div>
          </Col>
          <Col lg='2'>
            <div className="hero__img-box mt-4">
              <video src={heroVideo} alt="heroImg" controls/>
            </div>
          </Col>
          <Col lg='2'>
            <div className="hero__img-box hero__video-box mt-5">
              <img src={heroImg02} alt="heroImg" />
            </div>
          </Col>
          <SearchBar/>
        </Row>
      </Container>
    </section>
    {/* // --------------------------------------------------------------------------------------- */}
    <section>
      <Container>
        <Row>
          <Col lg='3'>
            <h5 className="services__subtitle">What we serve</h5>
            <h2 className="services__title">We offer our best services</h2>
          </Col>
          <ServiceList/>
        </Row>
      </Container>
    </section>
    {/* ---------------------------Feature tour section-------------------------------------------- */}
    <section>
      <Container>
        <Row>
          <Col lg='12' className="mb-5">
            <Subtitle  subtitle={'Explore'}/>
            <h2 className="featured__tour-title">Our feature tours</h2>
          </Col>
          <FeatureTourList/>
        </Row>
      </Container>
    </section>

    {/* ------------------------------Experience section --------------------------------------------------- */}
      <section>
        <Container>
          <Row>
            <Col lg="6">
             <div className="experience__content">
              <Subtitle  subtitle={'Experience'}/>
              <h2>With our all experience <br/>we will serve you </h2>
              <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                <br/> Illum, quos? Lorem ipsum dolor sit amet consectetur adipisicing elit. </p>
             </div>
             <div className="counter__wrapper d-flex align-items-center gap-5">
              <div className="counter__box">
                <span>12+</span>
                <h6>Successfull Trip</h6>
              </div>
              <div className="counter__box">
                <span>3k+</span>
                <h6>Regular clients</h6>
              </div>
              <div className="counter__box">
                <span>10+</span>
                <h6>Years experience</h6>
              </div>
             </div>
            </Col>
            <Col lg='6'>
              <div className="experience__img">
                <img src={experienceImg} alt="" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* ---------------------------------------------------gallery section----------------------   */}
      <section>
        <Container>
          <Row>
            <Col lg='12'>
            <Subtitle subtitle={'Gallery'}/>
            <h2 className="gallery__title">
              Visit our customers tour gallery
            </h2>
            </Col>
            <Col lg='12'>
              <MasonryGallery/>
            </Col>
          </Row>
        </Container>
      </section>
      {/* --------------------------------Testimonial ------------------------------------------------- */}
      {/* <section>
        <Container>
          <Row>
            <Col lg='12'>
              <Subtitle subtitle={'Fans Love'}/>
              <h2 className="testimonial__title">What our fans say about us</h2>
            </Col>
            <Col lg='12'>
              <Testimonial/>
            </Col>
          </Row>
        </Container>
      </section> */}
      {/* ---------------------------Newsletter------------------------------------------------------------ */}
      <Newsletter/>
    </>
  );
};

export default Home;
